var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSelect',{attrs:{"label":_vm.$tk('PCountrySelect.Country'),"items":_vm.countries,"disabled":_vm.disabled,"itemText":"text","itemValue":"value"},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }